import { setupWorker } from 'msw/browser'
import { handlers as proposalsHandlers } from '../api/proposals-api.mock'
import { handlers as issuersHandlers } from '../api/issuers-api.mock'
import { handlers as authHandlers } from '../api/auth-api.mock'
import { handlers as featureFlagsHandlers } from '../api/feature-flags-api.mock'

// This configures a Service Worker with the given request handlers
export async function setupMsw() {
  // Create the worker instance
  const worker = setupWorker(
    ...proposalsHandlers,
    ...issuersHandlers,
    ...authHandlers,
    ...featureFlagsHandlers
  )

  // Start the worker
  await worker.start({
    onUnhandledRequest: 'bypass',
    quiet: true,
  })

  return worker
}
